import { Trophy, Medal } from "lucide-react";

function fmtVal(v) {
  if (!v) return "R$ 0";
  return v >= 1000 ? "R$ " + (v / 1000).toFixed(1) + "k" : "R$ " + v;
}

function getInitials(name) {
  if (!name) return "?";
  var parts = name.split(" ");
  var f = parts[0] ? parts[0][0] : "";
  var s = parts[1] ? parts[1][0] : "";
  return (f + s).toUpperCase();
}

function getMedalColor(idx) {
  if (idx === 0) return "text-amber-500";
  if (idx === 1) return "text-gray-400";
  if (idx === 2) return "text-amber-700";
  return "";
}

function getAvatarColor(idx) {
  var colors = ["bg-amber-500", "bg-gray-400", "bg-amber-700", "bg-[#3B82F6]", "bg-purple-500", "bg-emerald-500"];
  return colors[idx % 6];
}

function RankRow({ broker, idx }) {
  var isTop3 = idx < 3;
  var rowBg = isTop3 ? "bg-amber-50/30" : "";
  var avColor = getAvatarColor(idx);
  var initials = getInitials(broker.name);
  var scoreCls = isTop3 ? "text-amber-600" : "text-gray-500";

  return (
    <tr className={"border-b border-gray-50 " + rowBg}>
      <td className="py-3 px-3">
        {isTop3 ? <Medal className={"w-5 h-5 " + getMedalColor(idx)} /> : <span className="text-sm text-gray-400">{idx + 1}</span>}
      </td>
      <td className="py-3 px-3">
        <div className="flex items-center gap-2">
          <div className={"w-7 h-7 rounded-full flex items-center justify-center " + avColor}>
            <span className="text-white text-xs font-semibold">{initials}</span>
          </div>
          <p className="text-sm font-medium text-[#0A2F3D]">{broker.name}</p>
        </div>
      </td>
      <td className="py-3 px-3 text-sm text-gray-700">{broker.total_leads}</td>
      <td className="py-3 px-3 text-sm font-medium text-emerald-600">{broker.closed}</td>
      <td className="py-3 px-3 text-sm text-gray-700">{broker.conversion}%</td>
      <td className="py-3 px-3 text-sm font-semibold text-[#0A2F3D]">{fmtVal(broker.commission_total)}</td>
      <td className="py-3 px-3"><span className={"text-sm font-bold " + scoreCls}>{broker.score}</span></td>
    </tr>
  );
}

export default function BrokerRanking({ data }) {
  var list = data && data.ranking ? data.ranking : [];

  if (list.length === 0) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm border text-center text-gray-400 text-sm" data-testid="broker-ranking">
        Nenhum corretor encontrado
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100" data-testid="broker-ranking">
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-5 h-5 text-amber-500" />
        <h4 className="text-sm font-semibold text-[#0A2F3D]">Ranking de Corretores</h4>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[500px]">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">#</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Corretor</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Leads</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Vendas</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Conversao</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Comissao</th>
              <th className="text-left py-2 px-3 text-xs font-medium text-gray-500 uppercase">Score</th>
            </tr>
          </thead>
          <tbody>
            {list.map(function(b, idx) {
              return <RankRow key={b.broker_id} broker={b} idx={idx} />;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
